import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function PersonalizedCarousel({ pics }) {
  const [selectedPic, setSelectedPic] = useState(null);
  return (
    <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        spaceBetween={30}
        slidesPerView={2}
        navigation
        pagination={{ clickable: true }}
        onSwiper={(swiper) => console.log(swiper)}
        onSlideChange={() => console.log("slide change")}
      >
        {pics.map((pic, index) => (
          <SwiperSlide key={index}>
            <div
              style={{
                aspectRatio: "4 / 3",
                width: "100%",
                overflow: "hidden",
                borderRadius: "8px",
                cursor: "pointer",
              }}
              onClick={() => setSelectedPic(pic)} // 👈 al hacer click abre el popup
            >
              <img
                src={pic}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Popup */}
      {selectedPic && (
        <div
          onClick={() => setSelectedPic(null)} // 👈 clic en fondo o imagen para cerrar
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <img
            src={selectedPic}
            alt="Fullscreen"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "10px",
              objectFit: "contain",
            }}
          />
        </div>
      )}
    </div>
  );
}
